import styles from "../dashboard/MainContent.module.css";
import { HeaderBotList } from "./HeaderBotList";
import { ChartAndListBotActive } from "./ChartAndListBotActive";
import AdsComponents from "../ads/AdsComponents";
import TableHeader from "./TableHeader";
import ListBotActive from "./ListBotActive";
import { useEffect, useState } from "react";
import { botListTourSteps } from "../../data/tourData";
import DialogTour from "../dialogs/DialogTour";
import { useAuth } from "../../context/authContext";

export const MainContentBotList = () => {
  const { user } = useAuth();
  const [openDialog, setOpenDialog] = useState(null);

  //  Control Botlist Tour visibility (backend is_tourtip + localStorage)
  useEffect(() => {
    if (!user) return;

    // is_tourtip === true means tutorial already deactivated globally
    if (user.is_tourtip === true) return;

    const isBotlistTourDisabled =
      localStorage.getItem("tour_disabled_botlist") === "true";

    if (!isBotlistTourDisabled) {
      setOpenDialog("open-tour-botlist");
    }
  }, [user]);

  useEffect(() => {
    const handler = () => setOpenDialog("open-tour-botlist");
    window.addEventListener("open-botlist-tour", handler);
    return () => window.removeEventListener("open-botlist-tour", handler);
  }, []);

  return (
    <div>
      <DialogTour
        open={openDialog === "open-tour-botlist"}
        onClose={() => setOpenDialog(null)}
        steps={botListTourSteps}
        tourKey="botlist"
      />

      <HeaderBotList />

      <div className="flex md:hidden">
        <ListBotActive />
      </div>

      <div className="flex gap-4">
        <ChartAndListBotActive />
        <div className="w-[500px] bg-white rounded-xl flex-col hidden md:flex">
          <ListBotActive />
        </div>
      </div>

      <TableHeader />

      <div
        className={`w-full bg-white rounded-xl flex h-[300px]`}
        style={{ border: "1px solid #dde1e6" }}
      >
        <AdsComponents className={"!h-[300px]"} />
      </div>
    </div>
  );
};
